import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { flattenToAppURL } from '@plone/volto/helpers';
import config from '@plone/volto/registry';

const DropdownSlots = ({ slotsData, content }) => {
  const { slots } = config;
  const { data } = slotsData;

  const editableSlots = (() => {
    return Object.keys(slots)
      .filter((name) => slots[name].manage)
      .filter((name) => (data.items?.[name] ? data.items?.[name]?.edit : data?.can_manage_slots))
      .map((name) => ({ id: name, title: slots[name].title }));
  })();

  return (
    <div className="menu-more pastanaga-menu">
      <>
        <header>
          <FormattedMessage id="Manage Slots" defaultMessage="Manage Slots" />
        </header>
        {editableSlots.length ? (
          <div className="pastanaga-menu-list">
            <ul>
              {editableSlots.map(({ id, title }) => {
                const url = flattenToAppURL(content['@id']);
                return (
                  <li key={id}>
                    <Link key={id} to={`${url}${url.endsWith('/') ? '' : '/'}edit-slot/${id}`}>
                      {title}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        ) : (
          <div className="pastanaga-menu-list"></div>
        )}
      </>
    </div>
  );
};

DropdownSlots.propTypes = {
  slotsData: PropTypes.objectOf(PropTypes.any).isRequired,
  content: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default connect(
  (state) => ({
    slotsData: state.slots,
    content: state.content.data,
    currentLanguage: state.intl.locale,
  }),
  {},
)(DropdownSlots);
